import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import { StyledNoContent, StyledModalBodyRow } from './styled';

const NoModalContent = ({ message }) => (
  <StyledModalBodyRow>
    <Col>
      <StyledNoContent>
        {message || '\u00A0'}
      </StyledNoContent>
    </Col>
  </StyledModalBodyRow>
);

NoModalContent.propTypes = {
  message: PropTypes.any,
};

export default NoModalContent;